export const API_URL = 'https://us-central1-luna-register.cloudfunctions.net';



// WEBPACK FOOTER //
// ./src/config.js